import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import camelCase from "../../utils/camelCase";
import {
  AccountMenuWrapper,
  Avatar,
  Menu,
  ItemsWrapper,
  UserName,
  CompanyName,
  Link,
  IconWrapper,
  LinkLabel,
} from "./styles/actions-styles";
import userType from "./types/userType";
import menuItemType from "./types/menuItemType";

class AccountMenu extends Component {
  state = {
    dropdownVisible: false,
  };

  componentDidMount() {
    document.addEventListener("click", this.hideVisibility);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.hideVisibility);
  }

  toggleVisibility = () => {
    this.setState(({ dropdownVisible }) => ({
      dropdownVisible: !dropdownVisible,
    }));
  };

  hideVisibility = (e) => {
    if (e.target.id !== "user-menu-trigger") {
      this.setState({ dropdownVisible: false });
    }
  };

  render() {
    const { dropdownVisible } = this.state;
    const { user, menuItems } = this.props;

    return (
      <AccountMenuWrapper
        onClick={this.toggleVisibility}
        className={`${dropdownVisible ? "active" : null}`}
      >
        <Avatar src={user.avatarUrl} alt="img" id="user-menu-trigger" />
        <Menu id="user-menu" className={`${dropdownVisible ? "active" : null}`}>
          <ItemsWrapper>
            <UserName>{user.fullName}</UserName>
            <CompanyName>{user.companyName}</CompanyName>
            {menuItems.map((menuItem) => (
              <Link
                data-turbolinks="false"
                key={menuItem.label}
                title={menuItem.label}
                href={menuItem.href}
                className={menuItem.className || ""}
                id={menuItem.id && menuItem.id}
                data-test-id={camelCase(menuItem.label)}
              >
                {menuItem.icons.map((icon) => (
                  <IconWrapper key={`${menuItem.label}-${icon.name}`}>
                    <Icon name={icon.name} />
                  </IconWrapper>
                ))}
                <LinkLabel>{menuItem.label}</LinkLabel>
              </Link>
            ))}
          </ItemsWrapper>
        </Menu>
      </AccountMenuWrapper>
    );
  }
}

AccountMenu.propTypes = {
  user: userType.isRequired,
  menuItems: PropTypes.arrayOf(menuItemType).isRequired,
};

export default AccountMenu;
